import { render, staticRenderFns } from "./screenList-1.vue?vue&type=template&id=787d084b&scoped=true"
import script from "./screenList-1.vue?vue&type=script&lang=js"
export * from "./screenList-1.vue?vue&type=script&lang=js"
import style0 from "./screenList-1.vue?vue&type=style&index=0&id=787d084b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787d084b",
  null
  
)

export default component.exports